import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type EligibilitySuspendedProps = BaseNotificationItemProps & {
  type: 'eligibility_suspended'
  program: {
    id: string
    displayName: string
    color: string
    iconType?: string
  }
}

export function EligibilitySuspended({ program, ...props }: EligibilitySuspendedProps) {
  return (
    <NotificationItem
      {...props}
      title={`${program.displayName} Eligibility Suspended`}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{`Your eligibility to work on ${program.displayName} has been suspended.`}</p>
      }
    />
  )
}
